import { TrashIcon } from "@heroicons/react/outline"
import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import { EndpointConfig } from "../../config"
import { AuthContext } from "../../context/auth.context"
import { axiosInstance } from "../../lib/axios"
import Button from "../atoms/button.atom"
import { parseStringTemplate, flatten } from "../template-info/templateUtils"

function Company() {
	const { auth, setAuth } = useContext(AuthContext)
	const [btnLoading, setBtnLoading] = useState(false)
	const [selectedCompany, setSelectedCompany] = useState([])
	const [serverTemplates, setServerTemplates] = useState([])
	const [currentTemplate, setCurrentTemplate] = useState({})

	const getCompany = (query, hubId) => {
		return axiosInstance.get(EndpointConfig.hubAppCompany + `/${query}`, {
			headers: { "hub-id": hubId }
		})
	}

	const getTemplates = (hubId) => {
		return axiosInstance.get(EndpointConfig.VFSMSTemplates + "?filter=Companies", {
			headers: { "hub-id": hubId }
		})
	}

	const removeSelectedContact = ({ hs_object_id }) => {
		setSelectedCompany(selectedCompany.filter(({ hs_object_id: id }) => id !== hs_object_id))
	}

	const getTemplatePreview = ({ templateText, variablesFlatten }) => {
		try {
			return parseStringTemplate(templateText, variablesFlatten)
		} catch (err) {
			console.error(err)
			return templateText
		}
	}

	const sendSms = () => {
		if (!(selectedCompany && selectedCompany.length > 0)) {
			toast("Please select at least one contact")
			return
		}
		setBtnLoading(true)
		;(async () => {
			const reqCompany = selectedCompany.map((cont) => {
				const contVariablesFlatten = flatten("companies", cont)
				return {
					phone: cont.properties.phone.value,
					text: getTemplatePreview({
						templateText: currentTemplate.text,
						variablesFlatten: contVariablesFlatten
					}),
					hs_object_id: cont.companyId
				}
			})
			await axiosInstance.post(
				EndpointConfig.VFSendSMS,
				{
					contacts: reqCompany,
					templateId: currentTemplate._id,
					Whatsapp_toggle: true,
					module: "COMPANY"
				},
				{ headers: { "hub-id": hubId } }
			)

			toast("SMS Sent")
		})()
			.catch((err) => {
				console.log("🚀 ~ sendSms ~ err", err)

				if (err?.response?.data?.message) {
					toast(err.response.data.message)
				} else {
					toast("Something Went Wrong")
				}
			})
			.finally(() => setBtnLoading(false))
	}

	const location = useLocation()

	useEffect(() => {
		const urlSearchParam = new URLSearchParams(location.search)
		const hubspotDetails = {}
		for (const [key, value] of urlSearchParam) {
			hubspotDetails[key] = value
		}

		setAuth({ hubId: hubspotDetails.hubId })
		if(hubspotDetails && hubspotDetails?.cardToken) localStorage.setItem("token", JSON.stringify(hubspotDetails.cardToken))

		if (hubspotDetails.hs_object_id) {
			init(hubspotDetails.hs_object_id, hubspotDetails.hubId)
		}
	}, [])

	const init = async (companyId, hubId) => {
		try {
			const { data: companyData } = await getCompany(companyId, hubId)
			setSelectedCompany([companyData])

			const {
				data: { data: templateData }
			} = await getTemplates(hubId)
			setServerTemplates(templateData)
		} catch (error) {
			console.log("🚀 ~ company ~ init ~ error", error)
			toast("Something Went Wrong")
		}
	}

	const hubId = auth.hubId

	return (
		<>
			{hubId && (
				<>
					<div className="flex flex-col">
						<div className="my-2"></div>
						<div className="flex flex-row items-center justify-center">
							<div className="flex flex-col items-center justify-center h-full">
								{selectedCompany.length > 0 && (
									<div className="flex flex-col flex-1 p-4 bg-white rounded w-700">
										<label className="text-xs text-gray-500 uppercase">
											Selected Company
										</label>
										<div className="flex flex-row flex-wrap gap-2 mt-1 mb-3">
											{selectedCompany.map((cont, index) => {
												return (
													<div
														key={index}
														className="flex flex-row p-1 px-3 text-xs bg-gray-200 rounded-full"
													>
														<span className="mr-2">
															{cont?.properties?.name?.value} :{" "}
															{cont?.properties?.phone?.value}
														</span>
														<TrashIcon
															className="w-4 h-4 text-gray-500 cursor-pointer"
															onClick={() =>
																removeSelectedContact(cont)
															}
														/>
													</div>
												)
											})}
										</div>
										<label className="mt-4 text-xs text-gray-500 uppercase">
											Choose SMS template
										</label>
										<select
											className="w-full px-2 py-1 text-sm border border-solid border-blue"
											value={currentTemplate?._id}
											onChange={(e) => {
												setCurrentTemplate(
													serverTemplates.find(
														(t) => t._id === e.target.value
													) || {}
												)
											}}
										>
											<option>Select</option>
											{serverTemplates.map((template) => (
												<option key={template._id} value={template._id}>
													{template.name}
												</option>
											))}
										</select>

										{currentTemplate?._id && (
											<div className="flex flex-col my-4 mt-8">
												<label className="text-xs text-gray-500 uppercase">
													Template Text
												</label>
												<div className="mb-2">{currentTemplate.text}</div>

												<p className="mt-4 text-xs text-gray-400">
													This message will sent via AccountId:{" "}
													<b>{currentTemplate.userId}</b> and SenderId:{" "}
													<b>{currentTemplate.senderId}</b>
													<br />
													having DTL TemplateId as :{" "}
													<b>{currentTemplate.dtlTemplateId}</b>{" "}
												</p>

												<div className="flex flex-row gap-6">
													<div className="flex-[3]">&nbsp;</div>
													<div className="flex-1">
														&nbsp;
														{btnLoading ? (
															<Button className="text-black bg-red-100 pointer-events-none">
																Loading
															</Button>
														) : (
															<Button
																className="w-full"
																onClick={sendSms}
															>
																Send SMS
															</Button>
														)}
													</div>
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</>
			)}
		</>
	)
}

export default Company
